import { useMutation, UseMutationOptions } from 'react-query';

import { AuthUser } from 'types/interfaces/user/AuthUser';

import { AuthApi, AutoRegisterPayload } from 'api/AuthApi';

export const useAutoRegisterMutation = (
  options?: UseMutationOptions<AuthUser, unknown, AutoRegisterPayload, unknown>
) => {
  return useMutation((payload) => AuthApi.autoRegister(payload), options);
};
